import 'core-js';
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import '@/presentation/assets/styles/main.scss';
import '@/presentation/assets/styles/el-overwrites/index.scss';
import Vue from 'vue';
import setTitle from './utils/set-title';
import App from './App.vue';
import { router } from './routers';
import createBridge, { createEventHub } from '@patsnap-utils/store-connect';
import { PRESETS_TOKEN_BASE_AI_LAB } from 'library-@/token-base/presets';
import { initTransformCodeInterceptor } from 'library-@/apis/interceptors/transform_code.interceptor';
import { startup } from 'library-@/startup';
import { langGetter } from '@/infrastructure/locales';
import { setContainer } from '@patsnap/tahiti-core/ioc/inject';
import { container } from './inversify.config';
import { i18n } from './utils/i18n-instance';
import initExceedUsageErrorCatch from '@/utils/exceed-usage-error-catch';
import { headerService } from '@/services/header-service';
import { generateExceptionRedirector } from '@patsnap/common-ps-http';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { InitAiLab } from '@/infrastructure/api-functions/interface/init-ai-lab.interface';
import 'vue-resize/dist/vue-resize.css';
import { useAiLab } from '@/composables/use-ai-lab';

setContainer(container);

// 建立与头部的通讯
window.$bridge = createBridge({
    headerConfig: {
        inputType: 'noInput',
        publicModule: false,
        moduleName: 'aiLab',
    },
});
Vue.prototype.$eventHub = createEventHub(window.$bridge);

(async () => {
    // @ts-ignore
    const [, locale] = await startup({
        headerService,
        projectName: 'AI-Lab',
        preset: PRESETS_TOKEN_BASE_AI_LAB,
        pageInit() {
            const initService = injectService<InitAiLab>(InitAiLab);
            return initService.initAiLab().then(() => {
                useAiLab().hasAILabPermission.value = true;
            }).catch(err => {
                // 如果是首页允许进入
                if (!/^#\/[^?]*[a-zA-Z]/.test(window.location.hash)) {
                    return Promise.resolve();
                } else {
                    return generateExceptionRedirector(403, '/request_demo?project=others')(err);
                }
            });
        },
    });

    // 根据语言修改 title
    setTitle({ locale, isWhiteLabel: headerService.whiteLabel });

    // i18n初始化
    const locales = await langGetter(locale);
    i18n.locale = locale;
    i18n.setLocaleMessage(locale, locales[locale]);

    // 添加拦截器
    initTransformCodeInterceptor(i18n);
    initExceedUsageErrorCatch();

    // 移除页面加载动画
    window.hidePageLoading && window.hidePageLoading();

    // 加载dom
    new Vue({
        el: '#app',
        i18n,
        router,
        render: h => h(App),
    });
})();
